import moment from 'moment';
import { Cell } from 'react-table';

const promotionStatus = [
  { name: 'Yes', value: 1 },
  { name: 'No', value: 0 },
];

const promotionsColumn = [
  {
    Header: 'Promotion title',
    accessor: 'title',
  },
  {
    Header: 'Start date',
    accessor: 'startDate',
    Cell: ({ row }: Cell) =>
      moment(row.values.startDate).format('D MMM YYYY, hh:mm A'),
  },
  {
    Header: 'End date',
    accessor: 'deadline',
    Cell: ({ row }: Cell) =>
      moment(row.values.deadline).format('D MMM YYYY, hh:mm A'),
  },
  {
    Header: 'Status',
    accessor: 'isActive',
    Cell: ({ row }: Cell) => (row.values.isActive ? 'Active' : 'Inactive'),
  },
  {
    Header: 'Actions',
    accessor: 'actions',
  },
];

export { promotionStatus, promotionsColumn };
